import defaultLiterals from './en.json';
import es from './es.json';
import vi from './vi.json';

const locales = {
  en: defaultLiterals,
  es,
  vi
};

export function getI18n(lang = 'en') {
  return locales[lang] ?? locales['en'];
}
